export function parseDate(dateString) {
    var reggie = /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/;
    var dateArray = reggie.exec(dateString);
    var dateObject = new Date(
        (+dateArray[1]),
        (+dateArray[2]) - 1, // Careful, month starts at 0!
        (+dateArray[3]),
        (+dateArray[4]),
        (+dateArray[5]),
        (+dateArray[6])
    );
    return dateObject;
}

export function prettyDate(date) {
    var monthNames = [
        "января", "февраля", "марта",
        "апреля", "мая", "июня", "июля",
        "августа", "сентября", "октября",
        "ноября", "декабря"
    ];
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
}

export function prettyDateTime(date) {
    var monthNames = [
        "января", "февраля", "марта",
        "апреля", "мая", "июня", "июля",
        "августа", "сентября", "октября",
        "ноября", "декабря"
    ];
    let minutes = "" + date.getMinutes();
    if (minutes.length < 2) {
        minutes = "0" + minutes;
    }
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear() + " " + date.getHours() + ":" + minutes;
}

export function prepareDateFields(object) {
    for (let field in object) {
        if (typeof object[field] === 'object') {
            if (Array.isArray(object[field])) {
                for (let i = 0; i < object[field].length; i++) {
                    if (typeof object[field][i] === 'object') {
                        prepareDateFields(object[field][i]);
                    }
                }
            } else {
                prepareDateFields(object[field]);
            }
        }
        if ((field === "started") || (field === "created") || (field === "ended") || (field === "time")) {
            let timeStr = "" + object[field];
            if (timeStr.length > 14) {
                object[field] = parseInt(timeStr.substr(0, 13));
            }
        }
    }
}


export function getTimestampFields(object) {
    let fields = [];
    for (let field in object) {
        if (typeof object[field] === 'object') {
            if (Array.isArray(object[field])) {
                for (let i = 0; i < object[field].length; i++) {
                    if (typeof object[field][i] === 'object') {
                        let childFields = getTimestampFields(object[field][i]);
                        fields = fields.concat(childFields.map(f => field + '.' + f));
                    }
                }
            } else {
                let childFields = getTimestampFields(object[field]);
                fields = fields.concat(childFields.map(f => field + '.' + f));
            }
        }
        if ((field === "started") || (field === "created") || (field === "ended") || (field === "time")) {
            fields.push(field);
        }
    }
    return fields;
}

export function calculateElapsedTime(startDate) {
    const currentDateTime = new Date();
    const elapsedMilliseconds = currentDateTime - startDate;
    const elapsedHours = elapsedMilliseconds / (1000 * 60 * 60);
    return {
        elapsedHours: Math.floor(elapsedHours),
        elapsedMilliseconds
    }
}